import React, {useEffect, useState} from "react";
import * as echarts from "echarts/core";
import {ResizeSensor} from "@blueprintjs/core";

// Import bar charts, all with Chart suffix
import {
    BarChart,
    LineChart
} from 'echarts/charts';
// import the tooltip, title, and rectangular coordinate system components, all suffixed with Component
import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    LegendComponent
} from 'echarts/components';
// Import the Canvas renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
    CanvasRenderer
} from 'echarts/renderers';

// Libs
import useResizeSensorHandler from "../hooks/use-resize-sensor-handler";

// Register the required components
echarts.use([TitleComponent, TooltipComponent, LegendComponent, GridComponent, DatasetComponent, BarChart, LineChart, CanvasRenderer]);

const Chart = (props) => {

    const {id, config, data = []} = props;

    // Chart
    const [chart, setChart] = useState();

    // Resize sensor state
    const [resizeSensorEntries, setResizeSensorEntries] = useState(null);
    const chartSize = useResizeSensorHandler(resizeSensorEntries);
    const chartWidth = (chartSize && chartSize.width) || 0;
    const chartHeight = (chartSize && chartSize.height) || 0;

    // Initialize the echarts instance
    useEffect(() => {
        const myChart = echarts.init(document.getElementById(id), {}, { locale: "ES" });
        drawChart(myChart, config, data);
        setChart(myChart);
    }, []);

    // Redraw chart when data changes
    useEffect(() => {
        if (chart) {
            drawChart(chart, config, data);
        }
    },[config, data]);

    // Resize chart
    if (chart && chartWidth && chartHeight) {
        chart.resize({
            width: chartWidth,
            height: chartHeight
        })
    }

    return (
        <div style={{ flex: 1, position: "relative" }}>
            <ResizeSensor onResize={setResizeSensorEntries}>
                <div id={id} style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                }} />
            </ResizeSensor>
        </div>
    );
};

export default Chart;

const drawChart = (chart, config, data) => {
    chart.setOption({
        dataset: data,
        ...config
    });
}